export enum CalcFeeActionsTypes {
  SET_STEPS_DISCOUNT_CATEGORIES = 'SET_STEPS_DISCOUNT_CATEGORIES',
}
